import { type RunStatus } from "./useCompetitorLinkRemovalDetail";

const NON_TERMINAL_STATUSES: RunStatus[] = ["scanning", "awaiting_confirmation", "removing"];

// Прогон можно отменить, пока он не дошёл до терминального состояния.
export function isCancellable(status: RunStatus): boolean {
  return NON_TERMINAL_STATUSES.includes(status);
}
